/**
 * Продолжение оформления подписки после входа.
 *
 * Гость нажал «Оформить» → открылся экран входа. Продолжать должен НЕ тот
 * экземпляр карточки, по которой кликнули: после входа витрина перестраивается
 * (пока неизвестно, есть ли у вошедшего подписка, карточка подписки заменена
 * заглушкой, а модалка пополнения могла закрыться), и карточки к этому моменту
 * уже нет. Поэтому продолжение исполняет `SubscriptionResumeHost`, который
 * смонтирован в `App` всегда, а карточка лишь передаёт ему, что продолжать.
 */
let handler = null;
/** Регистрирует исполнителя (см. `SubscriptionResumeHost`). */
export function registerSubscriptionResumeHandler(fn) {
    handler = fn;
}
/**
 * Продолжить оформление подписки по пакету. `false` — исполнителя нет
 * (хост не смонтирован): ничего не произойдёт, пользователь нажмёт ещё раз.
 */
export function runSubscriptionResume(pkg, provider) {
    if (!handler)
        return false;
    handler(pkg, provider);
    return true;
}
